import { action, makeObservable, observable, runInAction } from "mobx";
import { getNotificationSettings } from "shared/api/notificationService/settings";
import { RootStore } from "app/rootStore";
import { NotificationSettings } from "shared/interfaces/notificationSettings";

export class AppSettingsStore {
    private rootStore: RootStore;
    @observable appSettings: NotificationSettings | null = null;

    constructor(rootStore: RootStore) {
        makeObservable(this);
        this.rootStore = rootStore;
    }

    @action.bound
    public async requestSystemSettings(): Promise<void> {
        const settings = await getNotificationSettings();

        runInAction(() => {
            this.appSettings = settings;
        });
    }
}
